import type { ComponentType } from 'react'

import type { TransKey } from '@/i18n'
import { RoutePath } from '@/RoutePath'

import PkgActionsSvg from './assets/tour-actions.svg?react'
import AddressesSvg from './assets/tour-addresses.svg?react'
import PackagesSvg from './assets/tour-packages.svg?react'
import ReadySvg from './assets/tour-ready.svg?react'
import UniteSvg from './assets/tour-unite.svg?react'

export type TourPlacement = 'top' | 'bottom' | 'center'

export type OnboardingTourStep = {
  id: string
  route: RoutePath
  /** CSS selector for the spotlight target. Null for centered steps. */
  targetSelector: string | null
  placement: TourPlacement
  illustration: ComponentType<{ className?: string }>
  titleKey: TransKey
  bodyKey: TransKey
  buttonKey: TransKey
  /** When true, expand the package actions menu on the demo card. */
  forcePkgActionsOpen?: boolean
  injectDemoPkgs?: boolean
  /**
   * Scroll the page so the target leaves enough viewport room for the tour card
   * (used for mid-page targets like package actions / unite button).
   */
  scrollToFitCard?: boolean
  isFinal?: boolean
}

export const ONBOARDING_TOUR_STEPS: OnboardingTourStep[] = [
  {
    id: 'addresses-tab',
    route: RoutePath.ClientAddresses,
    targetSelector: '[data-tour="tour-addresses-tab"]',
    placement: 'bottom',
    illustration: AddressesSvg,
    titleKey: 'onboarding.step1Title',
    bodyKey: 'onboarding.step1Body',
    buttonKey: 'onboarding.continue',
  },
  {
    id: 'packages-tab',
    route: RoutePath.ClientPkg,
    targetSelector: '[data-tour="tour-packages-tab"]',
    placement: 'bottom',
    illustration: PackagesSvg,
    titleKey: 'onboarding.step2Title',
    bodyKey: 'onboarding.step2Body',
    buttonKey: 'onboarding.continue',
    injectDemoPkgs: true,
  },
  {
    id: 'pkg-actions',
    route: RoutePath.ClientPkg,
    targetSelector: '[data-tour="tour-pkg-actions"]',
    placement: 'top',
    illustration: PkgActionsSvg,
    titleKey: 'onboarding.step3Title',
    bodyKey: 'onboarding.step3Body',
    buttonKey: 'onboarding.continue',
    forcePkgActionsOpen: true,
    injectDemoPkgs: true,
    scrollToFitCard: true,
  },
  {
    id: 'unite-button',
    route: RoutePath.ClientPkg,
    targetSelector: '[data-tour="tour-unite-button"]',
    placement: 'bottom',
    illustration: UniteSvg,
    titleKey: 'onboarding.step4Title',
    bodyKey: 'onboarding.step4Body',
    buttonKey: 'onboarding.continue',
    injectDemoPkgs: true,
    scrollToFitCard: true,
  },
  {
    id: 'ready',
    route: RoutePath.ClientPkg,
    targetSelector: null,
    placement: 'center',
    illustration: ReadySvg,
    titleKey: 'onboarding.step5Title',
    bodyKey: 'onboarding.step5Body',
    buttonKey: 'onboarding.finish',
    injectDemoPkgs: true,
    isFinal: true,
  },
]

export const ONBOARDING_TOUR_TOTAL_STEPS = ONBOARDING_TOUR_STEPS.length
